<template>
  <g aria-hidden="true">
    <path d="M14.58 9.469L12 3.979l-2.58 5.488-1.028.157-4.742.725 4.175 4.273L7.65 15.7l-.81 4.958L12 17.808l.92.508 4.24 2.34-.986-6.033.745-.763 3.43-3.51-5.77-.881zm1.313-1.899l7.66 1.17a.53.53 0 0 1 .421.372.567.567 0 0 1-.131.561l-5.544 5.675 1.309 8.01a.561.561 0 0 1-.208.536.501.501 0 0 1-.549.042L12 20.155l-6.851 3.782a.501.501 0 0 1-.55-.042.561.561 0 0 1-.207-.535l1.309-8.012L.157 9.673a.567.567 0 0 1-.131-.561.53.53 0 0 1 .421-.373L8.11 7.57 11.534.28A.538.538 0 0 1 12.002 0c.192 0 .37.107.468.281l3.423 7.29z"
          fill-rule="nonzero" v-if="!filled"
    />
    <path d="M15.893 7.57l7.66 1.17a.53.53 0 0 1 .421.372.567.567 0 0 1-.131.561l-5.544 5.675 1.309 8.01a.561.561 0 0 1-.208.536.501.501 0 0 1-.549.042L12 20.155l-6.851 3.782a.501.501 0 0 1-.55-.042.561.561 0 0 1-.207-.535l1.309-8.012L.157 9.673a.567.567 0 0 1-.131-.561.53.53 0 0 1 .421-.373L8.11 7.57 11.534.28A.538.538 0 0 1 12.002 0c.192 0 .37.107.468.281l3.423 7.29z"
          fill-rule="evenodd" v-else
    />
  </g>
</template>

<script>
export default {
  props: {
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
